import React, { Fragment, useState, useEffect, useRef } from 'react';
import { translate } from '../../../Services/translation';
import { SubscriptionPausedStatus } from '../../../constants';

const MyPageSubscriptionPauseOrCancel = (props) => {
const [showConfirmPopUp, setshowConfirmPopUp] = useState(false);
const [isCancel, setisCancel] = useState(false);
const [isExpanded, setIsExpanded] = useState(false);
const [needsToggle, setNeedsToggle] = useState(false);
const [pausedIsExpanded, setPausedIsExpanded] = useState(false);
const [pausedNeedsToggle, setPausedNeedsToggle] = useState(false);

const descriptionRef = useRef(null);
const pausedDescriptionRef = useRef(null);

useEffect(() => {
    const checkHeight = () => {
        if (descriptionRef.current) {
            if (descriptionRef.current.scrollHeight >= 89) {
                setNeedsToggle(true);
            }
        }
    };

    const observer = new MutationObserver(() => {
        checkHeight();
    });

    if (descriptionRef.current) {
        observer.observe(descriptionRef.current, { childList: true, subtree: true });
    }

    checkHeight();
    window.addEventListener('resize', checkHeight);
    return () => {
        observer.disconnect();
        window.removeEventListener('resize', checkHeight);
    };
}, []);

useEffect(() => {
    const checkPausedHeight = () => {
        if (pausedDescriptionRef.current) {
            if (pausedDescriptionRef.current.scrollHeight >= 89) {
                setPausedNeedsToggle(true);
            }
        }
    };

    const observer = new MutationObserver(() => {
        checkPausedHeight();
    });

    if (pausedDescriptionRef.current) {
        observer.observe(pausedDescriptionRef.current, { childList: true, subtree: true });
    }

    checkPausedHeight();
    window.addEventListener('resize', checkPausedHeight);
    return () => {
        observer.disconnect();
        window.removeEventListener('resize', checkPausedHeight);
    };
}, []);

const toggleText = () => {
    setIsExpanded(!isExpanded);
};
const togglePausedText = () => {
    setPausedIsExpanded(!pausedIsExpanded);
};
    return (<Fragment>  
        <div className='mypage-subscription__pause-wrapper'>
            <a className='mypage-subscription__go-back-button' onClick={() => props.hide()}>
                {props.subscriptionStatus === SubscriptionPausedStatus ? translate("coptikk.adminportal.subscription.cancel")
                    : translate("coptikk.adminportal.subscription.pauseorstoptext")}
            </a>
            {props.subscriptionStatus === SubscriptionPausedStatus ?
                <div>
                    <p className='mypage-subscription__pause-title'>{translate("coptikk.mypage.subscription.thinkcancelheader")}</p>
                    <p className='mypage-subscription__pause-description'
                            ref={pausedDescriptionRef}
                            style={{
                                maxHeight: pausedIsExpanded ? 'none' : '85px',
                                overflow: pausedIsExpanded ? 'visible' : 'hidden',
                                transition: 'max-height 0.3s ease',
                                WebkitLineClamp: 3,
                                WebkitBoxOrient: 'vertical',
                                display: pausedIsExpanded ? 'block' : '-webkit-box',
                                whiteSpace: 'normal',
                            }}
                        >  
                        {translate("coptikk.mypage.subscription.thinkcanceldescription")}
                        </p>
                        {pausedNeedsToggle && (
                            <div onClick={togglePausedText} className="toggle">
                                {pausedIsExpanded ?
                                    <p className="show-less">{translate("coptikk.product.showless")}</p> :
                                    <p className="read-more">{translate("coptikk.product.readmore")}</p>
                                }
                            </div>
                        )}
                    <div>
                        <a className='button cancel-button' onClick={() =>  {
                            setisCancel(true);
                            setshowConfirmPopUp(true);
                        }}>{translate("coptikk.adminportal.subscription.cancel")}</a>
                    </div>
                </div>
                : <div>
                    <p className='mypage-subscription__pause-title'>{translate("coptikk.mypage.subscription.thinkpauseorcancelheader")}</p>
                    <div>
                        <p className='mypage-subscription__pause-description'
                            ref={descriptionRef}
                            style={{
                                maxHeight: isExpanded ? 'none' : '85px',
                                overflow: isExpanded ? 'visible' : 'hidden',
                                transition: 'max-height 0.3s ease',
                                WebkitLineClamp: 3,
                                WebkitBoxOrient: 'vertical',
                                display: isExpanded ? 'block' : '-webkit-box',
                                whiteSpace: 'normal',
                            }}
                        >   
                        {translate("coptikk.mypage.subscription.thinkpauseorcanceldescription")}
                        </p>
                        {needsToggle && (
                            <div onClick={toggleText} className="toggle">
                                {isExpanded ?
                                    <p className="show-less">{translate("coptikk.product.showless")}</p> :
                                    <p className="read-more">{translate("coptikk.product.readmore")}</p>
                                }
                            </div>
                        )}
                    </div>
                    <div className='mypage-subscription__button-container'>
                        <a className='mypage-subscription__edit-button' onClick={() =>  {
                            setisCancel(false);
                            setshowConfirmPopUp(true);
                        }}>{translate("coptikk.adminportal.subscription.pausenext")}</a>
                        <div>{translate("coptikk.adminportal.subscription.ortext")}</div>
                        <a className='mypage-subscription__cancel-subscription-button' onClick={() => {
                            setisCancel(true);
                            setshowConfirmPopUp(true);
                        }}>{translate("coptikk.adminportal.subscription.cancel")}</a>
                    </div>
                </div>} 
        </div>   
        {showConfirmPopUp && 
        <div className='subscription-pop-up'>
            <div className='subscription-pop-up__content'>
                <h2 className='subscription-pop-up__title'>{translate("coptikk.mypage.subscription.pauseorcancelconfirmheader")}</h2>
                <p className='subscription-pop-up__description'>{translate("coptikk.mypage.subscription.pauseorcancelconfirmdescription")}</p>
                <a className='subscription-pop-up__pause-button' onClick={() => isCancel ? props.cancelSubscription() : props.pauseSubscription()}>{translate("coptikk.mypage.subscription.pauseorcancelconfirmbuttontext")}</a>
                <a className='subscription-pop-up__cancel-button' onClick={() => props.refresh()}>{translate("coptikk.mypage.subscription.pauseorcancelconfirmcancel")}</a>
            </div>
        </div>
        }           
    </Fragment>)
}

export default MyPageSubscriptionPauseOrCancel;